import { useEffect, useState } from 'preact/hooks'
import { navigate } from 'raviger'

import { home, loadHome } from '../utils/home'
import { logout, profile } from '../utils/session'
import { Calendar } from './calendar'
import { Leaderboard } from './leaderboard'
import { WorkoutCard } from './workout_card'

export function Home() {
  const [error, setError] = useState(null)

  useEffect(() => {
    loadHome().catch((e) => setError(e.code))
  }, [])

  async function doLogout() {
    await logout()
    navigate('/login')
  }

  const data = home.value

  return (
    <main class="page home">
      <header class="top">
        <h1>Reto Saludable 2026</h1>
        <span class="muted">{profile.value?.displayName}</span>
      </header>
      {error && <p class="error">{error}</p>}
      {data && (
        <WorkoutCard
          today={data.today}
          calendar={data.calendar}
          streak={data.profile.currentStreak}
        />
      )}
      {data && <Calendar calendar={data.calendar} />}
      {data && <Leaderboard rows={data.leaderboard} />}
      <button class="link" onClick={doLogout}>Salir</button>
    </main>
  )
}
